<template>
    <div
        class="container sticky_nav_container d-flex justify-content-center align-items-center "
    >
        <div
            v-for="(item, key) in items"
            :key="key"
            class="col px-lg-5 text-nowrap mt-md-1 nav_link scrollto "
        >
            <a :href="'#'+item.link" @click.stop.prevent="scrollTo(item.link)">
                <span :class="classname">{{ item.text }}</span>
            </a>
        </div>
    </div>
</template>

<script>
window.addEventListener('scroll', function(e) {
    const sticky = document.getElementById('module_sticky');
    const el = document.getElementById('module_top');
    var viewportOffset = el.getBoundingClientRect();
    var bottom = viewportOffset.bottom;
    if(bottom <= 0){
        sticky.classList.add('position-fixed');
    }else{
        sticky.classList.remove('position-fixed');
    }
});
export default {
    props: {
        items: {
            type: Array,
            default: []
        },
        classname: {
            type: String,
            default: ""
        }
    },
    methods: {
        scrollTo(item) {
            this.$emit("scroll-to", item);
        }
    }
};
</script>

<style></style>
